import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const TopNavItemContainer = forwardRef((props, ref) => {
  const { children, className, ...rest } = props

  const classes = ['dev_dash__top-nav-item--container', className]
    .join(' ')
    .trim()

  return (
    <li className={classes} ref={ref} {...rest}>
      {children}
    </li>
  )
})

TopNavItemContainer.displayName = 'TopNavItemContainer'
TopNavItemContainer.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
}
